import { jwtDecode } from 'jwt-decode';

import { GateDealer } from 'modules/gates/types/Dealer';
import type { Token } from 'modules/vehicleCheck/types/GetContextResponse';

import { ContextResponse, Dealer } from './types/ContextResponse';

export const mergeContextWithToken = (context: Partial<ContextResponse> = {}, token: string): ContextResponse => {
  const safeContext = context ?? {};

  try {
    const decodedToken = jwtDecode<Token>(token);
    return {
      ...safeContext,
      type: decodedToken.type ?? safeContext.type,
      origin: decodedToken.origin ?? safeContext.origin,
      kioskId: decodedToken.kiosk_id ?? safeContext.kioskId,
      kioskType: decodedToken.kiosk_type ?? safeContext.kioskType,
      kioskModel: decodedToken.kiosk_model ?? safeContext.kioskModel,
    } as ContextResponse;
  } catch (e) {
    console.error('Failed to decode token:', e);
    return safeContext as ContextResponse;
  }
};

export const mapDealerIdsToNames = <T extends Dealer | GateDealer>(dealers: T[]): Record<string, string> =>
  dealers?.reduce<Record<string, string>>(
    (acc, dealer) => ({ ...acc, [dealer.id]: (dealer as Dealer).dealerName ?? (dealer as GateDealer).name }),
    {}
  );
